import { BASENAME } from "../../constants/Globals";
import { getCookie, getCookieDomain } from "../../helpers/Session";
const init = {
  userId: getCookie("sidedCurrentUserId"),
  isLogin: false,
  isLoading: false,
  isVerified: false,
  user: null,
  loginError: "",
  forgotPasswordErr: "",
  forgotPasswordSuc: "",
};

export const loginReducer = (state = init, action) => {
  switch (action.type) {
    case "USER_LOADING":
      return {
        ...state,
        isLoading: true,
      };
    case "USER_LOADED":
      if (window.location.href.indexOf("/onboarding") === -1) {
        const userData = action.payload.data;
        if (!userData.contactVerified) {
          window.location.href = BASENAME + "/onboarding";
        }
      }

      return {
        ...state,
        isLogin: true,
        isLoading: false,
        isVerified: action.payload.data.contactVerified,
        user: action.payload.data,
      };
    case "LOGIN": {
      // Remove old localStorage keys if present
      localStorage.removeItem("selNetworkId");
      // Set cookies for auth keys, then reload after a short delay to ensure cookies are set
      const isLocalhost =
        window.location.hostname === "localhost" ||
        window.location.hostname === "127.0.0.1";
      const domainAttr = isLocalhost ? "" : `; domain=.${getCookieDomain()}`;
      document.cookie = `sidedAccessToken=${action.payload.token}; path=/${domainAttr}`;
      document.cookie = `sidedAccessTokenExpireAt=${action.payload.tokenExpireAt}; path=/${domainAttr}`;
      document.cookie = `sidedAccessRefreshToken=${action.payload.refreshToken}; path=/${domainAttr}`;
      document.cookie = `sidedAccessRefreshTokenExpireAt=${action.payload.refreshTokenExpireAt}; path=/${domainAttr}`;
      document.cookie = `sidedCurrentUserId=${action.payload.data.user.id}; path=/${domainAttr}`;
      window.location.reload();
      //window.location.href = BASENAME;
      return {
        ...state,
        userId: action.payload.data.user.id,
        isLogin: true,
        isLoading: false,
        user: action.payload.data.user,
      };
    }
    case "AUTH_ERROR":
    case "LOGIN_FAIL":
      return {
        ...state,
        isLogin: false,
        isLoading: false,
        loginError: action.payload,
      };
    case "LOGOUT_SUCCESS":
    case "TOKEN_REFRESH_ERROR": {
      // Remove cookies for auth keys
      document.cookie =
        `sidedAccessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${getCookieDomain()};`;
      document.cookie =
        `sidedAccessTokenExpireAt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${getCookieDomain()};`;
      document.cookie =
        `sidedAccessRefreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${getCookieDomain()};`;
      document.cookie =
        `sidedAccessRefreshTokenExpireAt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${getCookieDomain()};`;
      document.cookie =
        `sidedCurrentUserId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${getCookieDomain()};`;
      window.location.href = BASENAME;
      return {
        ...state,
        userId: null,
        isLogin: false,
        isLoading: false,
        user: null,
      };
    }
    case "TOKEN_REFRESHED": {
      document.cookie = `sidedAccessToken=${action.payload.token}; path=/; domain=.${getCookieDomain()}`;
      document.cookie = `sidedAccessTokenExpireAt=${action.payload.tokenExpireAt}; path=/; domain=.${getCookieDomain()}`;
      document.cookie = `sidedAccessRefreshToken=${action.payload.refreshToken}; path=/; domain=.${getCookieDomain()}`;
      document.cookie = `sidedAccessRefreshTokenExpireAt=${action.payload.refreshTokenExpireAt}; path=/; domain=.${getCookieDomain()}`;
      return {
        ...state,
      };
    }
    case "APIKEY_LOADED":
      localStorage.setItem("apiKey", action.payload.token);
      localStorage.setItem("apiKeyExpireAt", action.payload.tokenExpireAt);
      return {
        ...state,
      };
    case "APIKEY_LOAD_ERROR":
      localStorage.removeItem("apiKey");
      localStorage.removeItem("apiKeyExpireAt");
      return {
        ...state,
      };
    case "FORGOT_PASSWORD":
      setTimeout(() => {
        window.location.href = BASENAME;
      }, 4000);
      return {
        ...state,
        forgotPasswordErr: "",
        forgotPasswordSuc: action.payload,
      };
    case "FORGOT_PASSWORD_FAIL":
      return {
        ...state,
        forgotPasswordErr: action.payload,
      };
    default:
      return state;
  }
};
